import React, { useState } from 'react';

const PropertyGallery = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  return (
    <div style={styles.gallery}>
      <div 
        style={{ 
          ...styles.mainImage,
          backgroundImage: `url(${images[currentIndex]})`
        }}
      >
        <button onClick={prevImage} style={styles.navButtonLeft}>&lt;</button>
        <button onClick={nextImage} style={styles.navButtonRight}>&gt;</button>
      </div>
      
      <div style={styles.thumbnails}>
        {images.map((img, index) => (
          <div
            key={index}
            style={{
              ...styles.thumbnail,
              border: index === currentIndex ? '3px solid #4a6fa5' : '3px solid transparent'
            }}
            onClick={() => setCurrentIndex(index)}
          >
            <img 
              src={img} 
              alt={`Thumbnail ${index}`} 
              style={styles.thumbnailImg} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  gallery: {
    position: 'relative',
    marginBottom: '2rem'
  },
  mainImage: {
    height: '450px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '8px',
    position: 'relative'
  },
  navButtonLeft: {
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    fontSize: '1.5rem',
    cursor: 'pointer'
  },
  navButtonRight: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    fontSize: '1.5rem',
    cursor: 'pointer'
  },
  thumbnails: {
    display: 'flex',
    gap: '10px',
    marginTop: '15px',
    overflowX: 'auto'
  },
  thumbnail: {
    width: '80px',
    height: '60px',
    borderRadius: '4px',
    overflow: 'hidden',
    cursor: 'pointer',
    flexShrink: 0
  },
  thumbnailImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
};

export default PropertyGallery;